import script from "./WksOpenInputOneFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksOpenInputOneFile.vue?vue&type=script&setup=true&lang=ts"

import "./WksOpenInputOneFile.vue?vue&type=style&index=0&id=7f48c1df&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f48c1df"]])

export default __exports__